import { BuildHtml } from "~/components/BuildHtml";
import { isPopulatedString } from "~/lib/shared/isPopulatedString";

type FooterProps = {
  footnote?: string;
  methodology?: string;
  chartIconContainer: React.ReactNode;
};

export const EvervizChartFooter = ({
  footnote,
  methodology,
  chartIconContainer,
}: FooterProps) => (
  <>
    <div className="mt-m flex flex-row flex-wrap-reverse place-items-end justify-between border-b-[1px] border-solid border-gray-300 pb-xs text-gray-700">
      <>
        <div className="max-w-[300px] flex-auto overflow-hidden">
          {chartIconContainer}
        </div>
        {isPopulatedString(footnote) && (
          <div className="flex w-1/2 flex-auto justify-end pb-xs text-right text-body-xsmall text-gray-700 md:pb-0">
            <span>{footnote}</span>
          </div>
        )}
      </>
    </div>
    {isPopulatedString(methodology) && (
      <div className="pt-xs text-body-xsmall text-gray-700">
        <BuildHtml html={methodology} />
      </div>
    )}
  </>
);
